/* eslint-disable */
/*
* filters.js
*
* Description: Holds common/global Filters.
*
* This file is part of: "http://apps.sundair.com/", "SunCrew - People"
* Copyright 2018,2019,2020,2021 Sundair GmbH
* Contact:  http://www.sundair.com/
* @author Christian Arp <christian.arp@sundair.com>
* @author Learek <michael.broeker@sundair.com>
*
*/
import Vue from 'vue';
import moment from 'moment';

import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';


Vue.filter("first4Chars", str => str.substring(0, 4)); // Unused
Vue.filter("last4Chars", str => str.substring(str.length - 4)); // Unused

/*******************************************************************************
* Filter:: 'birthdate'
*
* Desc: Filter: Format Date.
*
* @param {string} date (Date to reformat)
* @return {string}
*/
Vue.filter('birthdate', function (date) {

    return moment(date, moment.ISO_8601).format('DD.MM.YYYY'); // de:
    // return moment(date, moment.ISO_8601).format('MMM DD, YYYY'); // en: JAN 30, 2019

});


/*******************************************************************************
* Filter:: 'currency'
*
* Desc: Filter: Format Sum.
*
* @param {string} sum (Sum to reformat)
* @return {string}
*/
Vue.filter('currency', function (sum) {

    if(sum !== null) {
       return String(sum).indexOf(".") === -1 ? sum + '.00€' : sum + '€'; 
    }

    

});


/*******************************************************************************
* Filter:: 'rndAmntRUAFWZ'
*
* Desc: Filter: Format Value.
*
* @param {string} v (Value to reformat)
* @return {string}
*/
Vue.filter('rndAmntRUAFWZ', function (v) {

    var k,
        p;


    k = (Math.round(v * 100) / 100).toString();
    k += (k.indexOf('.') == -1) ? '.00' : '00';
    p = k.indexOf('.');


    return k.substring(0, p) + '.' + k.substring(p + 1, p + 3) + '€';

});


/*******************************************************************************
* Filter:: 'dayjsUtcDe'
*
* Desc:
* Note:
*
* @param {string} dateIso8601 (Date in ISO8601 format)

* @return {string}
*/
Vue.filter('dayjsUtcDe', function (dateIso8601) {

    let formattedDate;


    if (dateIso8601 === null) {
        formattedDate = "/";
    }

    if (dateIso8601 !== null) {
        dayjs.extend(utc);
        formattedDate = dayjs.utc(dateIso8601, dayjs.ISO_8601).format('DD.MM.YYYY');
    }


    return formattedDate;

}); // eo function dayjsUtcDe()


/*******************************************************************************
* Filter:: 'dayjsISOFormat'
*
* Desc:
* Note:
*
* @param {string} dateIso8601 (Date not in ISO8601 format)

* @return {string}
*/
Vue.filter('dayjsISOFormat', function (dateToFormat) {

    let formattedDate = null;


    if (dateToFormat !== null && dateToFormat !== '') {
        formattedDate = dayjs(dateToFormat).format("YYYY-MM-DD[T]01:00:00[Z]");
    }


    return formattedDate;

}); // eo function dayjsISOFormat()
